import {
  InsuranceRegistration,
  InsuranceRegistrationStatus,
  OnlineVerificationRegisteredType,
} from 'src/modules/entities/insurance-registration/entity'

export type InsuranceRegistrationResponse = {
  id: string
  status: InsuranceRegistrationStatus
  online_verification_registered_type: OnlineVerificationRegisteredType
  reservation_date_changed: boolean
  insurance_verification_url: string | null
}

export const parse = (
  resp?: InsuranceRegistrationResponse,
): InsuranceRegistration | null => {
  if (!resp) return null

  return {
    id: resp.id,
    status: resp.status,
    onlineVerificationRegisteredType: resp.online_verification_registered_type,
    reservationDateChanged: resp.reservation_date_changed,
    insuranceVerificationUrl: resp.insurance_verification_url,
  }
}
